import React, { useState, useEffect } from 'react';
import { AxiosInstance } from '../../../common/Loader/axios.config';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { IoClose } from 'react-icons/io5';

const EditVideoModal = ({ isOpen, onClose, selectedVideo }) => {
    const [formData, setFormData] = useState({
        title: selectedVideo.title,
        description: selectedVideo.description,
        price: selectedVideo.price,
        video_url: selectedVideo.video_url,
        stream_url: selectedVideo.stream_url,
        youtube_url: selectedVideo.youtube_url,
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        Object.keys(formData).forEach(key => {
            if (formData[key]) {
                formDataToSend.append(key, formData[key]);
            }
        });

        console.log("Form Data:");
        for (let [key, value] of formDataToSend.entries()) {
            console.log(`${key}:`, value);
        }

        setLoading(true);

        AxiosInstance.put(`/${selectedVideo._id}/content-video`, formDataToSend)
            .then(response => {
                console.log("Video Update Response", response);
                if (response.data.status === "success") {
                    const contentId = response.data.message._id;
                    Swal.fire({
                        icon: 'success',
                        title: 'Video Updated successfully!',
                        text: `${selectedVideo.title} has been updated successfully!`,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    onClose();
                    setLoading(false);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Update Failed',
                        text: `${response.data.message}`,
                    });
                    setLoading(false);
                }
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Upload Failed',
                    text: 'An error occurred while uploading.',
                });
                setLoading(false);
            });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
            <div className="bg-brand-background rounded-lg p-6 w-1/2 relative">
                <button onClick={onClose} className="absolute top-4 right-4 text-white text-2xl">
                    <IoClose />
                </button>
                <h2 className="text-lg font-semibold mb-4 text-white">Edit Video</h2>
                <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                    <div>
                        <label className="block mb-2 text-white">Title</label>
                        <input
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Price</label>
                        <input
                            type="text"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>

                    <div>
                        <label className="block mb-2 text-white">Video URL</label>
                        <input
                            type="text"
                            name="video_url"
                            value={formData.video_url}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>

                    <div>
                        <label className="block mb-2 text-white">Stream URL</label>
                        <input
                            type="text"
                            name="stream_url"
                            value={formData.stream_url}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>

                    <div>
                        <label className="block mb-2 text-white">Youtube URL</label>
                        <input
                            type="text"
                            name="youtube_url"
                            value={formData.youtube_url}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                        />
                    </div>
                    <div className="col-span-2">
                        <button type="submit" className="bg-primary text-white py-2 px-4 rounded">
                            {loading ? 'Updating...' : 'Update'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditVideoModal;
